import { render, staticRenderFns } from "./Fejadip.vue?vue&type=template&id=31e213cc&"
import script from "./Fejadip.vue?vue&type=script&lang=js&"
export * from "./Fejadip.vue?vue&type=script&lang=js&"
import style0 from "./Fejadip.vue?vue&type=style&index=0&id=31e213cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports